const _ = {
    invert: require('lodash/invert'),
};

const config = require('app/common/libs/config');

const methods = {

    REGION_TO_TLD: {
        [config.getRegionIdByName('moscow')]: 'ru',
        [config.getRegionIdByName('ukraine')]: 'ua',
        [config.getRegionIdByName('belarus')]: 'by',
        [config.getRegionIdByName('kazakhstan')]: 'kz',
        [config.getRegionIdByName('uzbekistan')]: 'uz',
    },

    /**
     * Получаем нац. домен по id региона
     * @param {Number} regionId
     * @returns {String}
     */
    getTldByRegion(regionId) {
        return methods.REGION_TO_TLD[regionId];
    },

    /**
     * Получаем id региона по нац. домену
     * @param {String} tld
     * @returns {Number}
     */
    getRegionByTld(tld) {
        return _.invert(methods.REGION_TO_TLD)[tld];
    },

};

module.exports = methods;
